import { useQuery } from "@tanstack/react-query";
import { ReviewServices } from "@/services/bedrock/ReviewServices";
import { designKeys } from "@/services/bedrock/queryKeys";

/** The player's reviews that can be shared, newest first. Refetches on focus since analysis may finish meanwhile. */
export function usePostableReviews(playerId: number | null | undefined, enabled: boolean) {
  return useQuery({
    queryKey: designKeys.postableReviews(playerId ?? -1),
    queryFn: () => ReviewServices.getReviews({ playerId: playerId ?? undefined, postable: true, perPage: 50 }),
    enabled: enabled && playerId != null,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
    select: page => page.content,
  });
}
